import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BACKEND_URL; //"http://localhost:3001"

const api = axios.create({
  baseURL: BASE_URL,
});

// Interceptor para agregar el token en cada petición
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("accessToken");
      window.dispatchEvent(new Event("unauthorized"));
    }
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      toast.error("No tienes permiso para realizar esta acción");
      window.dispatchEvent(new Event("forbidden"));
    }
    return Promise.reject(error);
  }
);

export default api;
